// --- Ingredient categories ---
const ingredientCategories = {
   "Whey Powder":"Proteins",
   "Amino Acids":"Proteins",
   "Cow Milk":"Proteins",
   "Goat Milk":"Proteins",
   "Lactose":"Carbohydrates",
   "Starch":"Carbohydrates",
   "Glucose Syrup":"Carbohydrates",
   "Maltodextrin":"Carbohydrates",
   "Soluble Dextrin":"Carbohydrates",
   "Palm Oil":"Fats & Oils",
   "Rapeseed Oil":"Fats & Oils",
   "Sunflower Oil":"Fats & Oils",
   "Coconut Oil":"Fats & Oils",
   "Soybean Oil":"Fats & Oils",
   "Fish Oil":"Fats & Oils",
   "Algae Oil":"Fats & Oils",
   "Mortierella Alpina Oil":"Fats & Oils",
   "Beta-Palmitate":"Fats & Oils",
   "ARA":"Fats & Oils",
   "DHA":"Fats & Oils",
   "Ascorbyl Palmitate":"Fats & Oils",
   "Vitamin A":"Vitamins",
   "Vitamin B":"Vitamins",
   "Vitamin B1":"Vitamins",
   "Vitamin B2":"Vitamins",
   "Vitamin B3":"Vitamins",
   "Vitamin B5":"Vitamins",
   "Vitamin B6":"Vitamins",
   "Vitamin B12":"Vitamins",
   "Vitamin C":"Vitamins",
   "Vitamin D3":"Vitamins",
   "Vitamin E":"Vitamins",
   "Vitamin K":"Vitamins",
   "Biotin":"Vitamins",
   "Nicotinamide":"Vitamins",
   "Folic Acid":"Vitamins",
   "Choline":"Vitamins",
   "Inositol":"Vitamins",
   "Metafolin":"Vitamins",
   "Taurine":"Vitamins",
   "Calcium":"Minerals & Electrolytes",
   "Magnesium":"Minerals & Electrolytes",
   "Zinc":"Minerals & Electrolytes",
   "Iron":"Minerals & Electrolytes",
   "Copper":"Minerals & Electrolytes",
   "Manganese":"Minerals & Electrolytes",
   "Potassium":"Minerals & Electrolytes",
   "Sodium":"Minerals & Electrolytes",
   "Chloride":"Minerals & Electrolytes",
   "Phosphorus":"Minerals & Electrolytes",
   "Iodine":"Minerals & Electrolytes",
   "Galacto-Oligosaccharides":"Prebiotics & Probiotics",
   "Bifidobacterium Breve M-16V":"Prebiotics & Probiotics",
   "Lactic Acid":"Prebiotics & Probiotics",
   "Emulsifiers":"Emulsifiers & Stabilizers",
   "Sunflower Lecithin":"Emulsifiers & Stabilizers",
   "Thickener":"Emulsifiers & Stabilizers",
   "Citric Acid":"Emulsifiers & Stabilizers",
   "Orthophosphoric Acid":"Emulsifiers & Stabilizers",
   "Nucleotides":"Nucleotides"
};